export class OrderItem {
    public OrderId: number;
    public Position: number;
    public ItemId: number;
    public Quantity: number;
    public Comment: string;
    public Price: number;
}
